import { isScheduleOnly } from './feature-permissions';

export const userTypes = {
  admin: 'Admin',
  fieldTechnician: 'Field Technician',
  accounting: 'Accounting',
  fleetMaintenance: 'Fleet Maintenance',
  projectManagement: 'Project Management',
  dispatcher: 'Dispatcher',
  machineShop: 'Machine Shop',
};

export const userTypesArray = [
  'Admin',
  'Field Technician',
  'Accounting',
  'Fleet Maintenance',
  'Project Management',
  'Dispatcher',
  'Machine Shop',
]

//* Schedule-Only companies can no longer assign Machine Shop; currentType keeps an existing Machine Shop user selectable
export const getAssignableUserTypes = (organization, currentType) =>
  isScheduleOnly(organization)
    ? userTypesArray.filter((type) => type !== userTypes.machineShop || type === currentType)
    : userTypesArray;